<template>
  <div v-if="visible" class="chat-float-entry" @click="goChat">
    <div class="bubble">
      <van-icon name="chat-o" size="26" color="#fff" />
    </div>
    <span v-if="unread > 0" class="badge">{{ unread > 99 ? '99+' : unread }}</span>
  </div>
</template>

<script>
import { getChatStatus } from '@/api/chat'
import chatSocket from '@/utils/chatSocket'

export default {
  name: 'ChatFloatEntry',
  data() {
    return {
      unread: 0,
      canChat: false,
      isChatAdmin: false,
      pollingTimer: null
    }
  },
  computed: {
    userId() {
      return this.$store.state.userInfo?.id || 0
    },
    isLogin() {
      return !!this.userId
    },
    // 在聊天页面时不显示气泡
    visible() {
      return this.isLogin && this.canChat && this.$route.path !== '/chat'
    }
  },
  watch: {
    userId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.init()
        } else {
          this.destroy()
        }
      }
    },
    '$route.path'(path) {
      // 从聊天页离开时刷新未读数
      if (path !== '/chat' && this.isLogin && this.canChat) {
        this.fetchStatus()
      }
    }
  },
  mounted() {
    // userId的watch immediate=true已处理初始化
  },
  beforeDestroy() {
    this.destroy()
  },
  methods: {
    async init() {
      await this.fetchStatus()
      if (this.canChat) {
        this.connectSocket()
        this.startPolling()
      }
      // 监听全局禁用事件（API返回403时触发）
      document.addEventListener('chat-banned', this.onBanned)
    },
    destroy() {
      this.stopPolling()
      chatSocket.off('message', this.onMessage)
      chatSocket.off('banned', this.onBanned)
      document.removeEventListener('chat-banned', this.onBanned)
      // 注意：不在此处关闭WebSocket，因为聊天页面也在用
    },
    async fetchStatus() {
      if (!this.userId) return
      try {
        const res = await getChatStatus(this.userId)
        this.canChat = res.canChat
        this.isChatAdmin = res.isChatAdmin
        this.unread = res.unread || 0
      } catch (e) {
        console.error('获取聊天状态失败', e)
      }
    },
    connectSocket() {
      if (!chatSocket.connected) {
        chatSocket.connect(this.userId)
      }
      chatSocket.on('message', this.onMessage)
      chatSocket.on('banned', this.onBanned)
    },
    onMessage(data) {
      // 收到新消息，如果不在聊天页，未读数+1
      if (this.$route.path !== '/chat') {
        this.unread++
      }
    },
    onBanned() {
      this.canChat = false
      this.unread = 0
    },
    startPolling() {
      this.stopPolling()
      // 每30秒轮询一次状态（兜底，防止WebSocket消息丢失）
      this.pollingTimer = setInterval(() => {
        if (this.$route.path !== '/chat') {
          this.fetchStatus()
        }
      }, 30000)
    },
    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },
    goChat() {
      this.$router.push('/chat')
    }
  }
}
</script>

<style scoped>
.chat-float-entry {
  position: fixed;
  right: 16px;
  bottom: 80px;
  z-index: 999;
  width: 52px;
  height: 52px;
}
.bubble {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #07c160, #06ad56);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(7, 193, 96, 0.4);
  cursor: pointer;
  transition: transform 0.2s;
}
.bubble:active {
  transform: scale(0.92);
}
.badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  padding: 0 5px;
  border-radius: 10px;
  background: #ff4d4f;
  color: #fff;
  font-size: 11px;
  text-align: center;
  font-weight: bold;
  box-shadow: 0 0 0 2px #fff;
}
</style>
